'use client'

interface EmptyNewsStateProps {
  title?: string
  description?: string
}

export function EmptyNewsState({ 
  title = "Chưa có tin tức", 
  description = "Hiện tại chưa có tin tức nào được đăng tải. Vui lòng quay lại sau." 
}: EmptyNewsStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="w-24 h-24 mx-auto mb-6 text-gray-400">
        <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1.5}
            d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
          />
        </svg>
      </div>
      
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {title}
      </h3>
      
      <p className="text-gray-600 text-center max-w-md">
        {description}
      </p>
      
      <button 
        onClick={() => window.location.reload()}
        className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium transition-colors"
      >
        Tải lại
      </button>
    </div>
  )
}
